/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  FunctionComponent,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { MdSentimentDissatisfied } from 'react-icons/md'
import { useHistory } from 'react-router-dom'

import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import Modal from 'shared/components/Modal'
import Text from 'shared/components/Text'
import Button from 'shared/components/Button'
import { colors } from 'shared/styles/colors'
import ModalSelectFrotista from 'shared/components/ModalSelectFrotista'
import SnackBar from 'shared/components/SnackBar'
import { IGetCartoes } from 'modules/pagamentos/domain/usecases/GetCartoes'
import { IVerifyPassword } from 'modules/pagamentos/domain/usecases/VerifyPassword'
import { useFrotista } from 'modules/user/hooks/useFrotista'
import Frotista from 'modules/user/domain/entities/Frotista'

import IConsultaCartoesResponseDTO from '../../domain/entities/IConsultaCartoesResponseDTO'
import { useCartao } from '../../hooks/useCartao'
import {
  BreadCrumb,
  Container,
  ContainerCards,
  ContainerIcon,
  Content,
  PageTitle,
} from './styles'
import ModalSenha from './../components/ModalSenha'
import ModalContaEmAnalise from './../components/ModalContaEmAnalise'
import EStatusConta from 'modules/lotes/domain/entities/EStatusConta'
import ModalContaRejeitada from './../components/ModalContaRejeitada'
import DadosConta from './components/DadosConta'
import ListServicoFinanceiro from './components/ListServicoFinanceiro'
import { formatBreadCrumb } from '../../../../shared/components/BasePage/formatBreadCrumb'
import { isValidValue } from '../../../../shared/utils/validates'

type TProp = {
  getCartao: IGetCartoes
  verifyPassword: IVerifyPassword
}

enum StepStatusConta {
  AprovadaOrSemConta = 0,
  ContaEmAnalise = 1,
  ContaRecusada = 2,
}

const PagamentoNew: FunctionComponent<TProp> = ({
  getCartao,
  verifyPassword,
}) => {
  const history = useHistory()
  const { frotistaId, setFrotista, setFrotistaId, frotista } = useFrotista()
  const [loading, setLoading] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [openModalPassword, setOpenModalPassword] = useState(false)
  const [requestError, setRequestError] = useState('')
  const [card, setCard] = useState<IConsultaCartoesResponseDTO>(
    {} as IConsultaCartoesResponseDTO,
  )
  const { cartao, setActiveMenu, clear, setCartao } = useCartao()
  const [openModalSelectFrotista, setOpenModalSelectFrotista] = useState(false)
  const [updateCartao, setUpdateCartao] = useState(false)
  const [openModalContaEmAnalise, setOpenModalContaEmAnalise] = useState(false)
  const [openModalContaRejeitada, setOpenModalContaRejeitada] = useState(false)
  const [statusConta, setStatusConta] = useState<StepStatusConta>(
    StepStatusConta.AprovadaOrSemConta,
  )

  const handleStatusConta = useCallback(
    (status: EStatusConta) => {
      switch (status) {
        case EStatusConta.EM_ANALISE:
          setOpenModalContaEmAnalise(true)
          setStatusConta(StepStatusConta.ContaEmAnalise)
          break
        case EStatusConta.RECUSADA:
          setOpenModalContaRejeitada(true)
          setStatusConta(StepStatusConta.ContaRecusada)
          break
        case null:
        case EStatusConta.CONTA_NAO_NECESSARIA:
          setStatusConta(StepStatusConta.AprovadaOrSemConta)
          history.push('/tmov-pay-instructions')
          break
        default:
          setStatusConta(StepStatusConta.AprovadaOrSemConta)
          break
      }
    },
    [statusConta],
  )

  const clerSelectedFrotista = useCallback(() => {
    setFrotista(new Frotista())
    setFrotistaId(undefined)
  }, [])

  const reset = () => {
    clerSelectedFrotista()
    clear()
    setOpenModalSelectFrotista(true)
    setActiveMenu('')
  }

  const handleGetCartao = useCallback(async () => {
    setUpdateCartao(true)
    handleStatusConta(frotista.status_conta)

    if (frotista.status_conta === EStatusConta.ATIVA) {
      try {
        setLoading(true)
        const result = await getCartao.execute(frotistaId)
        const haveCard = result.identificador

        setCard(result)
        setLoading(false)

        if (!haveCard) {
          setOpenModal(true)
          return
        }
        setUpdateCartao(false)
        setOpenModalPassword(true)
      } catch (e: unknown) {
        history.push('/tmov-pay-instructions')
        setOpenModal(true)
        setActiveMenu('')
        setCartao({} as IConsultaCartoesResponseDTO)
        if (e instanceof Error) {
          setRequestError(e.message)
        } else {
          setRequestError('Error ao obter o cartão')
        }
        setLoading(false)
      }
    }
  }, [getCartao, frotistaId, frotista])

  useEffect(() => {
    const locationState: { reloadHomePagamento?: boolean } = history.location
      .state as {
      reloadHomePagamento?: boolean
    }

    if (locationState?.reloadHomePagamento !== false) {
      reset()
    } else if (isValidValue(cartao)) {
      clear()
      handleGetCartao()
    }
  }, [])

  useEffect(() => {
    if (updateCartao) {
      handleGetCartao()
    }
  }, [updateCartao, frotistaId])

  const handleCloseModal = () => {
    setOpenModal(false)
    history.push('/lotes')
  }

  const cancelSelectCnpj = () => {
    history.push('/lotes')
  }

  const openModalSelectCnpj = () => {
    setOpenModalSelectFrotista(true)
    setStatusConta(StepStatusConta.AprovadaOrSemConta)
  }

  const componentStatusConta = useMemo(() => {
    return [
      {
        component: <></>,
      },
      {
        component: (
          <ModalContaEmAnalise
            openModalContaEmAnalise={openModalContaEmAnalise}
            setOpenModalContaEmAnalise={setOpenModalContaEmAnalise}
            openModalSelectCnpj={openModalSelectCnpj}
            clerSelectedFrotista={clerSelectedFrotista}
          />
        ),
      },
      {
        component: (
          <ModalContaRejeitada
            openModalContaRejeitada={openModalContaRejeitada}
            setOpenModalContaRejeitada={setOpenModalContaRejeitada}
            openModalSelectCnpj={openModalSelectCnpj}
            clerSelectedFrotista={clerSelectedFrotista}
          />
        ),
      },
    ]
  }, [
    statusConta,
    openModalContaEmAnalise,
    setOpenModalContaEmAnalise,
    setOpenModalPassword,
  ])

  return (
    <>
      <ModalSenha
        setActiveMenu={setActiveMenu}
        card={card}
        setCartao={setCartao}
        setOpenModalPassword={setOpenModalPassword}
        openModalPassword={openModalPassword}
        verifyPassword={verifyPassword}
        curvature={false}
      />
      <LoadingBackdrop open={loading} />
      <Content>
        <BreadCrumb>
          <PageTitle>{formatBreadCrumb('Pagamentos')}</PageTitle>
        </BreadCrumb>

        <Modal size="small" openModal={openModal} showCloseButton={false}>
          <Container>
            <ContainerIcon>
              <MdSentimentDissatisfied />
            </ContainerIcon>

            <div>
              <Text weight="700" size={24}>
                Ops!
              </Text>
            </div>

            <div>
              <Text>
                Este CNPJ ainda não tem uma conta TMOV Pay.
                <br />
                <br />
                <strong>
                  Não se preocupe, criaremos uma conta para você assim que a
                  primeira viagem for iniciada.
                </strong>
                <br />
                <br />
                Confira agora mesmo as nossas ofertas de frete e comece já!
              </Text>
            </div>

            <Button color={colors.green} onClick={handleCloseModal}>
              Ver ofertas
            </Button>
          </Container>
        </Modal>
        <ContainerCards>
          {isValidValue(cartao) &&
            frotista.status_conta === EStatusConta.ATIVA && (
              <>
                <DadosConta
                  openModalSelectFrotista={() => {
                    reset()
                    clear()
                  }}
                />
                <ListServicoFinanceiro />
              </>
            )}
          {console.log('cartao', isValidValue(cartao))}
          {!openModalSelectFrotista &&
            frotista.status_conta !== EStatusConta.ATIVA && (
              <>
                <div>frotista nao possui conta</div>
              </>
            )}
        </ContainerCards>
      </Content>
      <ModalSelectFrotista
        openModalSelectFrotista={openModalSelectFrotista}
        setOpenModalSelectFrotista={setOpenModalSelectFrotista}
        setCancelModalSelectFrotista={cancelSelectCnpj}
        setUpdateCartao={setUpdateCartao}
      />
      {componentStatusConta[statusConta].component}
      <SnackBar
        open={!!requestError}
        message={requestError}
        setOpen={() => setRequestError('')}
        severity={'error'}
      />
    </>
  )
}

export default PagamentoNew
